import { render, staticRenderFns } from "./RegistrationProblems.vue?vue&type=template&id=4cd4401c&scoped=true&"
import script from "./RegistrationProblems.vue?vue&type=script&lang=js&"
export * from "./RegistrationProblems.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationProblems.vue?vue&type=style&index=0&id=4cd4401c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4401c",
  null
  
)

export default component.exports